import styled, { css } from 'styled-components';
import theme from 'src/utils/theme';

export const MEDIA_CARD_WIDTH = theme.sz.s68;

export const ButtonContainer = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s3};
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary20};
    ${theme.typography.paragraph.s};
  `,
);

export const Info = styled.div(
  ({ theme }) => css`
    padding-top: ${theme.sz.s3};
    padding-bottom: ${theme.sz.s4};
    padding-left: ${theme.sz.s4};
    padding-right: ${theme.sz.s4};
    text-align: left;
  `,
);

export const MediaCard = styled.div(
  ({ theme }) => css`
    width: ${MEDIA_CARD_WIDTH};
    min-width: ${MEDIA_CARD_WIDTH};
    background-color: ${theme.co.neutral99};
    border: ${theme.bo.thinWidth} solid ${theme.co.neutral95};
    border-radius: ${theme.bo.mediumLarger};
    overflow: hidden;
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary0};
    ${theme.typography.heading.desktop.xxs};
  `,
);
